import {Component} from '@angular/core';
import {Alert, AlertController, App, Events, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {TranslateService} from "@ngx-translate/core";
import {VizixService} from "../providers/vizix.service";
import {Storage} from "@ionic/storage";
import {Keyboard} from '@ionic-native/keyboard';
import {SimulatorService} from "../providers/simulator.service";
import {RootPage} from "../pages/root/root";
import {ReaderService} from "../providers/reader.service";
import {VizixClientService} from 'vizixc';
import VizixRequestConfig from 'vizixc/dist/utils/vizixconfiguration';
import {STORAGE_TIME_OFFSET, TIME_OFFSET_ACCEPTABLE_DIFFERENCE, COLOR_APP_GENERAL} from './app.constants';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  private tag: string = '[APP_COMPONENT]';

  rootPage: any = RootPage;
  alert: Alert;

  constructor(platform: Platform,
              statusBar: StatusBar,
              splashScreen: SplashScreen,
              public translate: TranslateService,
              private _vizixService: VizixService,
              public storage: Storage,
              public events: Events,
              private keyBoard: Keyboard,
              private alertCtrl: AlertController,
              private readerService: ReaderService,
              private vizixClientService: VizixClientService,
              private simulatorService: SimulatorService,
              private app: App) {

    //Init simulator service
    this.simulatorService.init();

    platform.ready().then(() => {

      if (platform.is('cordova') && !platform.is('core') && !platform.is('mobileweb')) {

        console.log(this.tag, 'Platform is mobile!');

        // Init reader service
        this.readerService.initFromDevice();

        // Test Fairy
        TestFairy.begin("f58552066660a30851d4eb0a4e0f0146a6bcfae6");

        // General Layout Changes
        this.app.viewDidEnter.subscribe(() => statusBar.backgroundColorByHexString(COLOR_APP_GENERAL));
        // Keyboard
        this.keyBoard.disableScroll(false);
        this.keyBoard.hideKeyboardAccessoryBar(false);

      } else {
        console.log(this.tag, 'Platform is not mobile!');
      }

      // Start checking if system time has changed
      this.checkTimeChanges();
      platform.resume.subscribe(() => this.checkTimeChanges());

      splashScreen.hide();

      // Translations
      this.translate.setDefaultLang('en');
      this.storage.get('language')
        .then(language => {
          if (language) {
            this.setLanguage(language);
          } else {
            this.setLanguage(this.translate.currentLang || this.translate.defaultLang);
          }
        });
      this.subscribeEvents();
    });

  }

  subscribeEvents() {
    this.events.subscribe('language:changed', (lang: string) => this.setLanguage(lang));
  }

  setLanguage(language) {
    this.storage.set('language', language).then(() => this.translate.use(language));
  }

  timeChanged() {
    // Time has been changed
    if (!(this.alert instanceof Alert)) {
      this.alert = this.alertCtrl.create({
        title: this.translate.instant('time.alerts.timeChanged.title'),
        message: this.translate.instant('time.alerts.timeChanged.message'),
        buttons: [
          {
            text: this.translate.instant('time.alerts.timeChanged.buttons.ok'),
            handler: () => null
          }
        ]
      });
      this.alert.present();
      this.alert.onDidDismiss(() => this.alert = null);
    }
  }

  checkTimeChanges() {

    // Get token from service
    if (this.vizixClientService.$config instanceof VizixRequestConfig) {
      const token = this.vizixClientService.$config.token;
      // If user is logged in
      if (token) {
        const handleTimeResponse = (response: { offset: number, timestamp: number }) => {
          const local = new Date().getTime();
          const currentOffset = local - response.timestamp;
          const storedOffset = parseFloat(localStorage.getItem(STORAGE_TIME_OFFSET)) || 0;
          const difference = Math.abs(currentOffset - storedOffset);
          localStorage.setItem(STORAGE_TIME_OFFSET, currentOffset.toString());
          // Compare stored offset with current offset to determine if time was changed
          if (difference > TIME_OFFSET_ACCEPTABLE_DIFFERENCE) {
            this.events.publish('time:changed');
          }
        };

        // Get time from Vizix
        this._vizixService.timestamp().subscribe(handleTimeResponse);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts